<template>
  <div class="st-toolbar">
    <span class="label">{{ $t('chi58') }}</span>
    <el-date-picker
      v-model="dateRange"
      type="daterange"
      size="small"
      unlink-panels
      value-format="yyyy-MM-dd"
      :range-separator="$t('chi59')"
      :start-placeholder="$t('chi152')"
      :end-placeholder="$t('chi152')"
      style="width: 260px"
      @change="emitQuery"
    ></el-date-picker>
    <span class="label" style="margin-left: 8px">{{ $t('chi159') }}</span>
    <group-device-tree ref="multisel" v-model="ids" @done="emitQuery" @loaded="$emit('loaded', $event)" />
    <button type="button" class="btn-primary" @click="emitQuery">{{ $t('chi61') }}</button>
    <div class="spacer"></div>
    <button type="button" class="btn-soft" @click="$emit('export')">{{ $t('chi62') }}</button>
  </div>
</template>

<script>
import GroupDeviceTree from "./GroupDeviceTree.vue";

export default {
  name: "StatisticsToolbar",
  components: { GroupDeviceTree },
  props: {
    fromDate: { type: String, required: true },
    toDate: { type: String, required: true },
  },
  data() {
    return {
      dateRange: [this.fromDate, this.toDate],
      ids: [],
    };
  },
  methods: {
    emitQuery() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.$emit("update:fromDate", this.dateRange[0]);
        this.$emit("update:toDate", this.dateRange[1]);
        this.$emit("query", this.ids);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.st-toolbar {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #dcecf4;
  border-radius: 13px;
  padding: 15px 18px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
  display: flex;
  gap: 14px;
  align-items: center;
  flex-wrap: wrap;

  .label {
    color: #3aa8ff;
    font-weight: 700;
    white-space: nowrap;
  }

  .spacer {
    flex: 1;
  }

  .btn-primary {
    background: #28b7ee;
    border: 1px solid #28b7ee;
    color: #fff;
    border-radius: 9px;
    padding: 8px 15px;
    min-height: 38px;
    cursor: pointer;
    font: inherit;
  }

  .btn-soft {
    background: #eef9fd;
    color: #0c9ed7;
    border: 1px solid #d3edf7;
    border-radius: 9px;
    padding: 8px 15px;
    min-height: 38px;
    cursor: pointer;
    font: inherit;
  }
}
</style>
